import { render } from "./AdminIncome.vue?vue&type=template&id=35a8add3&scoped=true"
import script from "./AdminIncome.vue?vue&type=script&lang=js"
export * from "./AdminIncome.vue?vue&type=script&lang=js"

import "./AdminIncome.vue?vue&type=style&index=0&id=35a8add3&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a8add3"]])

export default __exports__